<template>
  <!-- modal cadastro -->
  <b-modal id="modal-cadastrar" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Cadastrar cupom</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastrar')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <h6><i class="fas fa-list"></i>Dados do Cupom</h6>
      <div class="row">

        <div class="col-12 col-md-6">
          <form-group id="cupomCupom"  label="Código do cupom *" :text="{ required: 'Obrigatório informar o código do cupom' }" :field="$v.cupom.codigo">
            <input type="text" class="form-control" id="codigo" placeholder="" v-model="cupom.codigo" />
          </form-group>
        </div>
        <div class="col-12 col-md-6">
          <form-group id="tipoCupom" label="Tipo de cupom" :text="{ required: 'Obrigatório informar o tipo de cupom' }" :field="$v.cupom.tipo_cupom_id">
            <select class="form-control" v-model="cupom.tipo_cupom_id">
              <option v-for="tipo in tipos_cupons" :value="tipo.id" v-bind:key="tipo.id">{{tipo.descricao}}</option>
            </select>
          </form-group>
        </div>

        <div class="col-12 col-md-6">
          <form-group id="descontoCupom"  label="Desconto (0 a 100%) *" :text="{ required: 'Obrigatório informar o percentual de desconto' }" :field="$v.cupom.perc_desconto">
            <input type="text" class="form-control" id="perc_desconto" placeholder="" v-model="cupom.perc_desconto" />
          </form-group>
        </div>

        <div class="col-12 col-md-6">
          <form-group id="qtdCupom"  label="Quantidade disponível *" :text="{ required: 'Obrigatório informar a quantidade máxima de utilização' }" :field="$v.cupom.qtd_max_utilizacao">
            <input type="text" class="form-control" id="qtd_max_utilizacao" placeholder="" v-model="cupom.qtd_max_utilizacao" />
          </form-group>
        </div>
      </div>

      <h6><i class="far fa-calendar-alt"></i> Tipo de disponibilidade</h6>

      <div class="row">
        <div class="col-12 col-md-6">
          <form-group id="fimValidadeCupom"  label="Válido até *" :text="{ required: 'Obrigatório informar o final da validade' }" :field="$v.cupom.data_fim_validade">
            <input v-if="isSafari" type="date" v-mask="['##/##/####']" class="form-control" id="data_fim_validade" placeholder="dd/mm/aaaa" v-model="cupom.data_fim_validade" />
            <input v-else type="date" class="form-control" id="data_fim_validade" placeholder="" v-model="cupom.data_fim_validade" />
          </form-group>
        </div>
        <div class="col-12 col-md-6">
          <form-group id="ciclosCupom"  label="Ciclos Válidos *" :text="{ required: 'Obrigatório informar o ciclo do cupom' }" :field="$v.cupom.ciclo">
            <input type="number" class="form-control" id="ciclo" placeholder="" v-model="cupom.ciclo" />
          </form-group>
        </div>
      </div>

      <h6 v-if="publicoAlvoCupons"><i class="fas fa-users"></i> Público alvo do cupom</h6>
      <div class="row" v-if="publicoAlvoCupons && cupom.publicoAlvoCupons">
        <div class="col-12">
          <p class="tit-checks">Planos<i class="fas fa-info-circle ml-2" v-b-popover.hover.top="'O cupom será aplicado para o(s) plano(s)'"></i></p>
        </div>
        <div v-for="plano in publicoAlvoCupons.planos_macro" v-bind:key="plano.id" class="col-12 col-md-4">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            :id="'publicoAlvoCuponsPlanos'+plano.id" :value="true"
            v-model="cupom.publicoAlvoCupons.planosMacro[plano.id].checked"
            @change="checkPlano(plano.id)"
            :ref="'publicoAlvoCuponsPlanos'+plano.id">
            <label class="custom-control-label" :for="'publicoAlvoCuponsPlanos'+plano.id" v-text="plano.nome"></label>
          </div>
        </div>
      </div>
      <div v-if="publicoAlvoCupons && cupom.publicoAlvoCupons" class="row">
        <div class="col-12">
          <p class="tit-checks mt-3">Periodicidade<i class="fas fa-info-circle ml-2" v-b-popover.hover.top="'O cupom será aplicado para a(s) periodicidade(s)'"></i></p>
        </div>
        <div v-for="periodo in publicoAlvoCupons.periodicidade" v-bind:key="periodo" class="col-12 col-md-4">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            :id="'publicoAlvoCuponsPeriodicidade'+periodo.id" :value="true"
            v-model="cupom.publicoAlvoCupons.periodicidade[periodo.id].checked"
            @change="checkPeriodicidade(periodo.id)"
            :ref="'publicoAlvoCuponsPeriodicidade'+periodo.id">
            <label class="custom-control-label" :for="'publicoAlvoCuponsPeriodicidade'+periodo.id" v-text="periodo.nome"></label>
          </div>
        </div>
      </div>
      <div v-if="publicoAlvoCupons && cupom.publicoAlvoCupons" class="row">
        <div class="col-12">
          <p class="tit-checks mt-3">Com adicionais<i class="fas fa-info-circle ml-2" v-b-popover.hover.top="'Cupom será aplicado somente se o usuário tiver esses adicionais'"></i></p>
        </div>
        <div v-for="plano_macro_required in publicoAlvoCupons.planos_macro_required" v-bind:key="plano_macro_required" class="col-12 col-md-4">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            :id="'publicoAlvoCuponsPlanoMacroRequired'+plano_macro_required.id" :value="true"
            v-model="cupom.publicoAlvoCupons.planosMacroRequired[plano_macro_required.id].checked">
            <label class="custom-control-label" :for="'publicoAlvoCuponsPlanoMacroRequired'+plano_macro_required.id" v-text="plano_macro_required.nome"></label>
          </div>
        </div>
      </div>

      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="editarCupom" v-if="isEdicao">Salvar</button>
          <button class="btn btn-primary mr-3" type="button" @click="cadastrarCupom" v-else>Cadastrar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import CupomAPI from '@/api/cupom-api'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'
import DateUtils, { DateConstants } from '@/core/util/date-utils'
import moment from 'moment'

export default {
  name: 'ModalCadastroCupom',
  components: { FormGroup },
  props: {
    cupomEdicao: Object,
    tipos_cupons: Array,
    publicoAlvoCupons: Object
  },
  data () {
    return {
      cupom: {
        tipo_cupom_id: 1,
        codigo: '',
        perc_desconto: '',
        ciclo: '',
        qtd_max_utilizacao: '',
        data_fim_validade: ''
      },
      teste: true
    }
  },

  computed: {
    isSafari: function () {
      let ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('safari') !== -1) {
        if (ua.indexOf('chrome') > -1) {
          return false
        } else {
          return true
        }
      }
      return false
    },
    isEdicao: function () {
      return this.cupomEdicao && this.cupomEdicao.id > 0
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()

      if (this.cupomEdicao) {
        this.cupom = Object.assign({}, this.cupomEdicao)
        if (this.isSafari) {
          this.cupom.data_fim_validade = moment(this.cupomEdicao.data_fim_validade).format('YYYY-DD-MM')
        } else {
          this.cupom.data_fim_validade = DateUtils.formatDate(DateUtils.parse(this.cupomEdicao.data_fim_validade), DateConstants.YYYY_MM_DD)
        }

        let planosMacro = []
        let periodicidade = []
        let planosMacroRequired = []

        this.publicoAlvoCupons.planos_macro.forEach(item => {
          let checked = false
          this.cupom.planos.forEach(plano => {
            if (plano.plano_macro_id === item.id) {
              checked = true
            }
          })
          planosMacro[item.id] = { 'id': item.id, checked, 'nome': item.nome }
        })
        this.publicoAlvoCupons.periodicidade.forEach(item => {
          let checked = false
          this.cupom.planos.forEach(plano => {
            if (plano.duracao === item.id) {
              checked = true
            }
          })
          periodicidade[item.id] = { 'id': item.id, checked, 'nome': item.nome }
        })
        this.publicoAlvoCupons.planos_macro_required.forEach(item => {
          let checked = false
          this.cupom.planos_macro_required.forEach(planoMacro => {
            if (planoMacro.pivot.plano_macro_id === item.id) {
              checked = true
            }
          })
          planosMacroRequired[item.id] = { 'id': item.id, checked, 'nome': item.nome }
        })

        this.cupom.publicoAlvoCupons = { planosMacro, planosMacroRequired, periodicidade }
      } else {
        this.cupom = {
          tipo_cupom_id: 1,
          codigo: '',
          perc_desconto: '',
          ciclo: '',
          qtd_max_utilizacao: '',
          qtd_utilizada: '',
          data_fim_validade: ''
        }

        let planosMacro = []
        let periodicidade = []
        let planosMacroRequired = []

        this.publicoAlvoCupons.planos_macro.forEach(item => {
          if (item.id === 7) {
            planosMacro[item.id] = { 'id': item.id, 'checked': false, 'nome': item.nome }
          } else {
            planosMacro[item.id] = { 'id': item.id, 'checked': true, 'nome': item.nome }
          }
        })
        this.publicoAlvoCupons.periodicidade.forEach(item => {
          periodicidade[item.id] = { 'id': item.id, 'checked': true, 'nome': item.nome }
        })
        this.publicoAlvoCupons.planos_macro_required.forEach(item => {
          planosMacroRequired[item.id] = { 'id': item.id, 'checked': false, 'nome': item.nome }
        })

        this.cupom.publicoAlvoCupons = { planosMacro, planosMacroRequired, periodicidade }
      }
    })
  },

  validations: {
    cupom: {
      tipo_cupom_id: { required },
      codigo: { required },
      perc_desconto: { required },
      ciclo: { required },
      qtd_max_utilizacao: { required },
      data_fim_validade: { required }
    }
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-cadastrar')
    },

    cadastrarCupom: function () {
      this.$v.cupom.$touch()
      if (!this.$v.cupom.$invalid) {
        const loader = this.$loading.show()
        let cupom = this.cupom
        if (this.isSafari) {
          cupom.data_fim_validade = moment(this.cupom.data_fim_validade, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }

        CupomAPI.salvar(cupom).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Cupom criado com sucesso'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar')
            this.$emit('cupomSalva', this.cupom)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },

    editarCupom: function () {
      this.$v.cupom.$touch()
      if (!this.$v.cupom.$invalid) {
        const loader = this.$loading.show()
        delete this.cupom.tipo_cupom
        let cupom = this.cupom
        if (this.isSafari) {
          cupom.data_fim_validade = moment(this.cupom.data_fim_validade, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }

        CupomAPI.editar(cupom).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Cupom atualizado com sucesso!'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar')
            this.$emit('cupomSalva', this.cupom)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },
    checkPlano (id) {
      if (this.cupom.publicoAlvoCupons.planosMacro[7].checked) {
        this.cupom.publicoAlvoCupons.periodicidade[12].checked = true
        this.$refs.publicoAlvoCuponsPeriodicidade12[0].checked = true
      }
    },
    checkPeriodicidade (id) {
      if (!this.cupom.publicoAlvoCupons.periodicidade[12].checked) {
        this.cupom.publicoAlvoCupons.planosMacro[7].checked = false
        this.$refs.publicoAlvoCuponsPlanos7[0].checked = false
      }
    }
  }
}
</script>
<style>
  div.modal-conta i.glyphicon-calendar{
    font-size: inherit;
  }
</style>
